import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { MailX } from "lucide-react";

// Unsubscribing is handled directly from the unsubscribe link in the footer of
// our emails, so this page is informational only.
const Unsubscribe = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="pt-32 pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-md mx-auto">
            <Card>
              <CardHeader>
                <CardTitle>Email preferences</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4 text-center">
                <MailX className="h-12 w-12 mx-auto text-muted-foreground" />
                <p>
                  To stop receiving RCN emails, use the "Unsubscribe" link at the
                  bottom of any email we've sent you.
                </p>
                <p className="text-sm text-muted-foreground">
                  Need help? Email us at{" "}
                  <a className="underline" href="mailto:info@rcnmo.com">
                    info@rcnmo.com
                  </a>
                  .
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Unsubscribe;
